/**
 * Tab Completados (pedido KP 14/09): los onboardings que ya terminaron — la
 * persona ingresó y todos los pasos del flow de People quedaron cerrados. Se
 * ve paso por paso igual que en Proceso (pipeline + detalle), pero sin mezclar
 * con lo que sigue vivo.
 */

import { useTranslation } from 'react-i18next';
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';
import { AlertCircle, CheckCircle2 } from 'lucide-react';
import { WinclapLoader } from '@/components/ui/winclap-loader';
import { WeekSplitTable } from './WeekSplitTable';
import { usePeopleFlowRows } from './usePeopleFlowRows';

export function OnboardingCompletedTab() {
  const { t } = useTranslation();
  const { rows, buckets, isLoading, error } = usePeopleFlowRows();

  if (isLoading) return <WinclapLoader />;
  if (error) {
    return (
      <Alert variant="destructive">
        <AlertCircle className="h-4 w-4" />
        <AlertTitle>{t('users.people_panel.load_error')}</AlertTitle>
        <AlertDescription>{error.message}</AlertDescription>
      </Alert>
    );
  }

  return (
    <div className="space-y-4">
      <p className="flex items-center gap-2 text-sm text-muted-foreground">
        <CheckCircle2 className="h-4 w-4 text-emerald-600 dark:text-emerald-400" />
        {t('users.people_panel.completed.desc', { count: buckets.completed.length })}
      </p>
      <WeekSplitTable rows={buckets.completed} allRows={rows} emptyText={t('users.people_panel.completed.empty')} />
    </div>
  );
}
